import { cn } from '@/helpers/shadcn/utils'

export type TimeRange = '3M' | '6M' | '9M' | 'YTD' | '1Y' | '5Y' | 'ALL'

const RANGES: TimeRange[] = ['3M', '6M', '9M', '1Y', '5Y', 'YTD']

/**
 * Compute dataZoom startValue/endValue for a given time range.
 * Returns null for 'ALL' (use default zoom behavior).
 */
export function getTimeRangeWindow(range: TimeRange): {
  startValue: number
  endValue: number
} | null {
  if (range === 'ALL') return null

  const now = new Date()
  const end = now.getTime()
  let start: Date

  switch (range) {
    case '3M':
      start = new Date(now.getFullYear(), now.getMonth() - 3, 1)
      break
    case '6M':
      start = new Date(now.getFullYear(), now.getMonth() - 6, 1)
      break
    case '9M':
      start = new Date(now.getFullYear(), now.getMonth() - 9, 1)
      break
    case 'YTD':
      // Federal fiscal year starts Oct 1 of prior calendar year
      start =
        now.getMonth() >= 9
          ? new Date(now.getFullYear(), 9, 1)
          : new Date(now.getFullYear() - 1, 9, 1)
      break
    case '1Y':
      start = new Date(now.getFullYear() - 1, now.getMonth(), 1)
      break
    case '5Y':
      start = new Date(now.getFullYear() - 5, now.getMonth(), 1)
      break
  }

  return { startValue: start.getTime(), endValue: end }
}

export function TimeRangeToggle({
  value,
  onChange,
}: {
  value: TimeRange
  onChange: (range: TimeRange) => void
}) {
  return (
    <div className="inline-flex rounded-md border border-primary-200 text-xs dark:border-primary-700">
      {RANGES.map((range, i) => {
        const isFirst = i === 0
        const isLast = i === RANGES.length - 1
        const isActive = value === range
        return (
          <button
            key={range}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(isActive ? 'ALL' : range)}
            className={cn(
              'px-1.5 py-0.5 font-medium transition-colors',
              isFirst && 'rounded-l-md',
              isLast && 'rounded-r-md',
              isActive
                ? 'bg-accent-100 text-accent-700 dark:bg-accent-900 dark:text-accent-300'
                : 'text-primary-500 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-200',
            )}
          >
            {range}
          </button>
        )
      })}
    </div>
  )
}
